
<div class="login-container">
  <div class="form-warning" *ngIf="errorMessage">
    {{errorMessage}}
  </div>
  <mat-card appearance="outlined" class="card-container">
    <form class="form-container" [formGroup]="form" name="login" (ngSubmit)="onSubmit()">
      <h2 class="title">Login</h2>
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Introduceti emailul dvs." type="text" formControlName="email" required>
        <mat-icon matPrefix>mail&nbsp;</mat-icon>
      </mat-form-field>
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Parolă</mat-label>
        <input matInput placeholder="Introduceti parola dvs." [type]="hide ? 'password' : 'text' " formControlName="password" required>
        <mat-icon matPrefix class="icon-key">key&nbsp;</mat-icon>
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
      <div class="button-navigation full-width">
        <button class="full-width" mat-raised-button type="submit" color="primary" [disabled]="!form.valid">
          Login
        </button>
      </div>
    </form>
  </mat-card>
</div>
